import { cn } from '@exam-room/utils';

interface CardProps extends React.ComponentProps<'div'> {
  children?: React.ReactNode | string;
}

export default function Card({ children, className, ...props }: CardProps) {
  return (
    <div
      className={cn(['flex flex-col rounded-2xl bg-white p-6 drop-shadow-md', className])}
      {...props}
    >
      {children}
    </div>
  );
}
